var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTuLasBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 112.17053,
    height: 101.38853,
    viewBox: "0 0 112.17053 101.38853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,76.041 H 84.128 V 0 H 0 Z",
    id: "path18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,101.38853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 84.128 V 76.041 H 0 Z",
    style: {
      fill: "#040606",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    clipPath: "url(#clipPath20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(37.0784,21.9101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.534,1.255 3.835,9.015 3.835,9.015 3.86,9.073 6.211,3.396 7.614,0 Z m -3.843,-2.479 h 6.348 v -2.443 h 2.492 v 2.443 h 6.424 L 3.889,15.098 Z M 19.212,26.519 V 37.143 H 16.634 V 26.995 c 0,-1.277 0,-2.599 -1.122,-3.549 -0.551,-0.469 -1.544,-0.809 -2.361,-0.809 -0.818,0 -1.811,0.34 -2.362,0.81 -1.122,0.949 -1.122,2.271 -1.122,3.548 V 37.143 H 7.089 V 26.519 c 0,-1.326 0.131,-2.734 1.08,-4.051 1.071,-1.467 2.886,-2.309 4.982,-2.309 2.096,0 3.911,0.842 4.983,2.311 0.948,1.316 1.078,2.723 1.078,4.049 M 27.758,5.823 c -0.691,0.689 -1.548,1.143 -2.622,1.61 l -1.55,0.677 c -0.585,0.257 -1.138,0.499 -1.578,0.939 -0.365,0.343 -0.477,0.602 -0.477,1.103 0,1.263 0.903,2.08 2.301,2.08 0.787,0 1.286,-0.257 1.559,-0.466 0.295,-0.237 0.63,-0.668 0.834,-1.073 l 0.208,-0.416 2.128,1.405 -0.17,0.328 c -0.41,0.792 -1.018,1.481 -1.713,1.943 -0.826,0.55 -1.696,0.795 -2.822,0.795 -2.911,0 -4.943,-1.88 -4.943,-4.572 0,-1.218 0.371,-2.095 1.241,-2.933 0.726,-0.701 1.508,-1.059 2.137,-1.347 L 23.879,5.157 C 24.666,4.798 25.288,4.515 25.71,4.116 26.164,3.7 26.376,3.197 26.376,2.533 c 0,-1.283 -0.743,-2.781 -2.834,-2.781 -0.871,0 -1.498,0.239 -2.028,0.767 -0.446,0.47 -0.76,1.137 -0.859,1.831 L 20.588,2.814 18.013,2.099 18.099,1.717 c 0.273,-1.214 0.863,-2.33 1.616,-3.058 0.981,-0.958 2.225,-1.423 3.802,-1.423 3.201,0 5.524,2.258 5.524,5.369 0,1.322 -0.407,2.345 -1.283,3.218 m -44.251,8.398 h -2.577 v -16.7 h 8.257 V 0 h -5.68 z m 15.177,22.922 h -10.31 V 34.665 H -7.76 V 20.444 h 2.578 v 14.221 h 3.866 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTuLasBlack);
export default __webpack_public_path__ + "static/media/logo-tu-las--black.1212187413760e90459edc3ad3d3751b.svg";
export { ForwardRef as ReactComponent };